import { MijnRoute } from '../../mijn-navigatie.model';

export const COLLECTION: MijnRoute = {
    path: 'incasso',
    navigationEvent: 'toIncasso',
    regex: /^\/incasso$/,
    webcomponent: 'mijn-transacties-incasso-webcomponent'
};
